/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=4c4ef537&"
import script from "./deliver.vue?vue&type=script&lang=js&"
export * from "./deliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports